import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import D365ScriptProvider from "../../../providers/d365-script-provider/d365-script-provider";

const PageBase = ({ children }) => {
  const { site } = useStaticQuery(query);

  return (
    <D365ScriptProvider
      leadSource={site.siteMetadata.leadSource}
      contactSource={site.siteMetadata.contactSource}
      vorneDomain={site.siteMetadata.vorneDomain}
    >
      <div>{children}</div>
    </D365ScriptProvider>
  );
};

const query = graphql`
  query {
    site {
      siteMetadata {
        titleBase
        leadSource
        contactSource
        vorneDomain
      }
    }
  }
`;

PageBase.propTypes = {
  metaTitle: PropTypes.string,
  metaDescription: PropTypes.string,
};

export default PageBase;
